<script setup lang="ts">
import Form from '@app/components/login/form.vue';
import Sso from '@app/components/login/sso.vue';
import Logo from '@ui/components/logo.vue';
import Loading from '@ui/components/loadingSpinner.vue';
import AlertsPanel from '@app/components/panels/alertsPanel.vue';
import { useLogin } from '@app/components/login/useLogin';
const { sso, form, alerts, workspace } = useLogin();
</script>
<template>
    <div class="mx-auto grid min-h-screen max-w-md items-center px-4">
        <div class="relative my-4 overflow-hidden rounded-md bg-white px-8 pt-3 shadow-lg ring-1 ring-black/5 md:my-16 md:scale-110 lg:my-32 lg:scale-125">
            <Logo
                v-if="!workspace"
                class="mx-auto flex h-24 w-40 items-stretch [&>*]:h-full [&>*]:w-full"
            ></Logo>
            <h2
                v-if="workspace"
                class="font-brand m-0 mt-4 p-0 text-lg font-bold text-gray-900"
            >
                {{ workspace.name }}
            </h2>
            <div
                v-show="form.loading"
                class="text-brand-500 absolute -inset-4 z-20 flex items-center justify-center bg-white/70 backdrop-blur-sm"
            >
                <Loading></Loading>
            </div>
            <AlertsPanel
                v-if="alerts?.alerts?.length > 0"
                :alerts="alerts.alerts"
                panel-class="!p-0 2xl:!p-0"
            ></AlertsPanel>
            <Form></Form>
            <div
                v-if="sso?.length > 0"
                class="relative -mx-8 flex flex-col gap-y-4 rounded-b-md border-t border-gray-200 bg-gray-50 px-8 pb-8 pt-8"
                :class="workspace ? 'mt-4' : 'mt-8'"
            >
                <div
                    v-if="!workspace"
                    class="absolute left-1/2 top-0 flex -translate-x-1/2 -translate-y-1/2 items-center gap-2 text-gray-400"
                >
                    <span class="inline-flex items-center rounded-full bg-white px-3 py-0.5 font-sans text-xs font-semibold uppercase leading-5 ring-1 ring-black/5">{{ $t('login.or') }}</span>
                </div>
                <Sso></Sso>
            </div>
        </div>
    </div>
</template>
